import * as React from 'react';
export const wingsfinancialSvg = React.forwardRef(
  function wingsfinancialSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#4075B9',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm24.842 10.412-4.195 16.56h-.893L16.27 12.33l-3.804 14.644h-.893l-4.044-16.1C7.057 8.997 6.706 7.904 5 7.904V7.01c2.328.17 4.597.17 6.915 0v.893c-1.054.16-2.057.07-2.057 1.777 0 .923 2.59 11.15 2.98 12.736L16.453 7.01h1.104l3.613 15.406c.763-2.84 2.77-10.287 2.77-12.967 0-1.455-1.134-1.556-2.038-1.556V7c1.747.17 3.353.17 5.099 0v.893c-1.244.261-1.797 1.054-2.168 2.51',
        fill: '#fff',
      }),
    );
  },
);
wingsfinancialSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wingsfinancial = {
  category: 'brand',
  colorable: false,
  name: 'wingsfinancial',
  svg: wingsfinancialSvg,
};
